import type { RideAudioSettings, RideAudioSettingsPatch } from './types.ts';

export const DEFAULT_RIDE_AUDIO_SETTINGS: RideAudioSettings = Object.freeze({
  masterVolume: 0.8,
  rideVolume: 0.85,
  windVolume: 0.7,
  uiVolume: 0.7,
  muted: false,
});

function normalizeVolume(value: unknown, fallback: number): number {
  if (typeof value !== 'number' || !Number.isFinite(value)) return fallback;
  return Math.min(1, Math.max(0, value));
}

export function normalizeRideAudioSettings(
  candidate: RideAudioSettingsPatch | undefined,
  fallback: RideAudioSettings = DEFAULT_RIDE_AUDIO_SETTINGS,
): RideAudioSettings {
  return {
    masterVolume: normalizeVolume(candidate?.masterVolume, fallback.masterVolume),
    rideVolume: normalizeVolume(candidate?.rideVolume, fallback.rideVolume),
    windVolume: normalizeVolume(candidate?.windVolume, fallback.windVolume),
    uiVolume: normalizeVolume(candidate?.uiVolume, fallback.uiVolume),
    muted: typeof candidate?.muted === 'boolean' ? candidate.muted : fallback.muted,
  };
}
